import React from "react";
import "./InsightStyle.scss";
import { insightTextContent } from "./constant/index";
import SectionHeading from "../Common_UI_Kit/SectionHeading";
import CustomButton from "../Common_UI_Kit/CustomButton";
import { useNavigate } from "react-router-dom";

const InsightSection = () => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate(`/contact-us`);
  };

  return (
    <section className="insight-section">
      <div className="insight-wrap">
        <SectionHeading>{insightTextContent.headingText}</SectionHeading>
      </div>

      <div className="insight-container">
        <div className="insight-wrap">
          <div className="insight-box">
            <div className="img-box">
              <img src={insightTextContent.imageSrc} alt="Image" />
            </div>

            <div className="text-box">
              <p className="para-text">{insightTextContent.paraText_1}</p>
              <p className="para-text">{insightTextContent.paraText_2}</p>
              <CustomButton buttonType="secondary" label={insightTextContent.btnText} onClick={handleButtonClick} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InsightSection;
